module.exports = __webpack_public_path__ + "img/MultiDays.0572604a.png";